import Cookies from 'js-cookie'

export default function IpRedirect () {
  // Check if the global object is defined
  // It's only defined when the setting is enabled for the current subsite - see controller.ip-redirect.php
  if (window.ip_redirect_objects === undefined) {
    return
  }

  const ipRedirectClass = new IpRedirectClass()
  ipRedirectClass.init()
}

class IpRedirectClass {
  constructor () {
    this.REST_URL = window.ip_redirect_objects?.ip_redirect_rest_url || null
    this.NONCE = window.ip_redirect_objects?.wp_rest_nonce || null
    this.POPUP_ELEMENT = null
  }

  init () {
    if (!this.REST_URL || !this.NONCE) {
      return
    }

    // Check if user has dismissed the popup in this session
    if (this.userHasDismissedPopup()) {
      return
    }

    this.getUserLanguage()
      .then(data => {
        // If no markup received, do nothing
        if (!data.popupMarkup) {
          return
        }

        // Insert popup HTML into the body
        document.body.insertAdjacentHTML("beforeend", data.popupMarkup)

        // Get popup element
        this.POPUP_ELEMENT = document.getElementById('mt-redirect-popup')

        this.addEventListeners()
      })
  }

  addEventListeners() {
    if (!this.POPUP_ELEMENT) {
      return
    }

    const closeElements = this.POPUP_ELEMENT.querySelectorAll('.mt-redirect-popup__overlay, #mt-redirect-popup-close, #mt-redirect-popup-go-to')

    if (closeElements.length > 0) {
      closeElements.forEach(el => {
        el.addEventListener('click', this.dismissPopup.bind(this))
      })
    }

    // Hide on escape key press
    document.addEventListener('keydown', this.handleKeydown)
  }

  handleKeydown(e) {
    if (e.key === 'Escape') this.dismissPopup()
  }

  dismissPopup() {
    if (this.POPUP_ELEMENT) {
      this.POPUP_ELEMENT.classList.remove('mt-redirect-popup--show')
    }
    this.setSessionDismissedCookie()
    document.removeEventListener('keydown', this.handleKeydown)
  }

  setSessionDismissedCookie () {
    Cookies.set('ip_redirect_dismissed', '1', { sameSite: 'strict' })
  }

  userHasDismissedPopup () {
    return Cookies.get('ip_redirect_dismissed') === '1'
  }

  async getUserLanguage () {
    try {
      // Get IP
      const ipRes = await fetch('https://api64.ipify.org?format=json')
      const { ip } = await ipRes.json()

      // Get geolocation
      const geoRes = await fetch(`https://ipapi.co/${ip}/json/`)
      const geoData = await geoRes.json()

      const response = await fetch(this.REST_URL, {
        method: 'POST',
        headers: {
          'X-WP-Nonce': this.NONCE,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          geoData
        })
      })

      return await response.json()
    } catch (error) {
      console.error('Error fetching IP: ', error)
    }
  }
}